import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import Modal from '@/components/Modals/Shared/Modal';
import ModalHeader from '@/components/Modals/Shared/ModalHeader';
import React from 'react';
import SignUpEmail from './SignUpEmail';
import { signupLadySmallUrl } from '@/utils/urls';
import styles from './SignUpModal.module.scss';

const headerText = <FormattedMessage id="signUpModal.header" />;

type Props = {
    bidderExists: boolean;
    cancelSignUp: (event: any) => void;
    error: string;
    isMobile: boolean;
    isTablet: boolean;
    openLoginModal: Function;
    setEmail: Function;
    show: boolean;
    submitCreateAccount: Function;
    submitted: boolean;
    whiteLabel: boolean;
};

const SignUpModal = (props: Props) => {
    const {
        bidderExists,
        cancelSignUp,
        error = '',
        isMobile,
        isTablet,
        openLoginModal,
        setEmail,
        show = false,
        submitCreateAccount,
        submitted = false,
        whiteLabel,
    } = props;

    const footerContent = (
        <FormattedMessage
            id="signUpModal.footer"
            values={{
                link: (
                    <Link key="link" onClick={openLoginModal}>
                        <FormattedMessage id="signUpModal.footerLink" />
                    </Link>
                ),
            }}
        />
    );

    const modalHeader = <ModalHeader content={headerText} hideLogo={whiteLabel} onHide={cancelSignUp} />;
    const modalLeftImage = isMobile && !isTablet ? null : <ImageWithFallback src={signupLadySmallUrl} />;
    const modalBody = (
        <div>
            <SignUpEmail
                bidderExists={bidderExists}
                error={error}
                setEmail={setEmail}
                submitCreateAccount={submitCreateAccount}
                submitted={submitted}
            />
        </div>
    );
    const modalFooter = <div>{footerContent}</div>;

    return (
        <Modal
            body={modalBody}
            contentLabel="SignUpModal"
            footer={modalFooter}
            footerClassName={styles.footer}
            header={modalHeader}
            leftImage={modalLeftImage}
            show={show}
        />
    );
};

export default SignUpModal;
